export const PRESCRIPTIONS_PRODUCT_UNITS = {
  metric: {
    ml: { id: 'ml', total: 'lit', factor: 1000 },
    g: { id: 'g', total: 'g', factor: 1 },
    lit: { id: 'lit', total: 'lit', factor: 1 },
    kg: { id: 'kg', total: 'kg', factor: 1 },
    t: { id: 't', total: 't', factor: 1 },
    seeds: { id: 'seeds', total: 'seeds', factor: 1 },
    kseeds: { id: 'kseeds', total: 'kseeds', factor: 1 },
    units: { id: 'units', total: 'units', factor: 1 },
    dose: { id: 'dose', total: 'dose', factor: 1 },
    sack: { id: 'sack', total: 'sack', factor: 1 },
    boxs: { id: 'boxs', total: 'boxs', factor: 1 },
  },
  imperial: {
    oz: { id: 'oz', total: 'lb', factor: 16 },
    pt: { id: 'pt', total: 'gal', factor: 8 },
    qt: { id: 'qt', total: 'gal', factor: 4 },
    lb: { id: 'lb', total: 'lb', factor: 1 },
    gal: { id: 'gal', total: 'gal', factor: 1 },
    'fl oz': { id: 'fl oz', total: 'gal', factor: 128 },
    seeds: { id: 'seeds', total: 'seeds', factor: 1 },
    kseeds: { id: 'kseeds', total: 'kseeds', factor: 1 },
    t: { id: 't', total: 'lb', factor: 0.0005 },
    ml: { id: 'ml', total: 'lit', factor: 1000 },
    lit: { id: 'lit', total: 'lit', factor: 1 },
    g: { id: 'g', total: 'g', factor: 1 },
    kg: { id: 'kg', total: 'kg', factor: 1 },
    boxs: { id: 'boxs', total: 'boxs', factor: 1 },
  },
};
